import { PluginSidebar } from '@wordpress/edit-post';
import BlockbiteSidebar from './sideBar.js';

const BlockbitePostSidebar = () => {
  return (
    <PluginSidebar name="plugin-sidebar-blockbite" title="Blockbite">
      <BlockbiteSidebar />
    </PluginSidebar>
  );
};

export default BlockbitePostSidebar;
